<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FM-Head-fmh"><span href="#/xhtml/contents#ack" title="Link target outside of Sample"><span class="ePub-B">Acknowledgments</span></span></p>
<p class="FM-Text-No-Indent-fmtx1-2">Writing is not a solitary endeavor. Thanks as always to my agent, Al Zuckerman, whose wisdom and mentorship continue to raise my game every day; and to my editor, Jen Enderlin, for her astute critiques and sharp eye for clean prose.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?cf92b4a4